import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
function CustomPopup(props) {

    const [inputValue, setInputValue] = useState(""); 
    const [error, setError] = useState("");

    useEffect(()=>{
      
        if(props.customPopupConfigs.runOnComponentMount){
            
            props.customPopupConfigs.runOnComponentMount();
        }
    },[])


    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        if (error) {
            setError(""); 
        }
    };
    
      const handleInputSubmit = () => {

        if (!inputValue.trim()) {
            setError("*This field is required.");
            return;
        }
        // Clear error if input is valid
        setError("");
        
        if (props.customPopupConfigs.onSubmitCallback) {
          props.customPopupConfigs.onSubmitCallback(inputValue); 
        }
      };

    return (
        <>    <section class="overlay-custom" >
            <div class="overlay-window-container-custom custom-popup" id={props.customPopupConfigs.htmlTagId} >
                <div class="overlay-window-custom" >
                    <div class="overlay-content padding-0">
                        <div class="overlay-header">
                            <div class="overlay-header-title"  >
                                {props.customPopupConfigs.title && <p>{props.customPopupConfigs.title}</p> }
                                {props.customPopupConfigs.subtitle && <p>{props.customPopupConfigs.subtitle}</p>}
                            </div>
                            { props.customPopupConfigs.closeOnClick && <div class="close-button" onClick={() => { props.customPopupConfigs.closeOnClick() }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15 5L5 15M5 5L15 15" stroke="#231F20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            }
                        </div>
                        
                         <div class="overlay-body-custom">
                            {props.customPopupConfigs.imageSrc && <div class="image"><img src={props.customPopupConfigs.imageSrc}></img></div>}
                                                        
                            {props.customPopupConfigs.customComponent }
                            {props.customPopupConfigs.heading && <p class="heading" >{props.customPopupConfigs.heading}</p> }
                            {props.customPopupConfigs.subHeading && <p class="subHeading">{props.customPopupConfigs.subHeading}</p>}
                            {props.customPopupConfigs.showInput && (
                               <div className="form-row">
                               <label> {props.customPopupConfigs.inputLabel || "Enter here"} <span style={{ color: "red" }}>*</span> </label>
                               <input name="bookingNum" id="bookingNum" type="text"
                                 inputMode={props.customPopupConfigs.inputMode || "text"}
                                 value={inputValue}
                                 onChange={handleInputChange}
                                 className="inputBox"
                               />
                               {error && ( <p style={{ marginTop: "5px", color: "#ff4d4f", fontSize: "12px", fontWeight: "500" }}>
                                   {error}
                                 </p>
                               )}
                             </div>
                             
                            )}
                        </div>
                        <div class="overlay-controls-custom" >
                             {props.customPopupConfigs.primaryOnClick && <button class="button primary" onClick={props.customPopupConfigs.showInput ? handleInputSubmit : props.customPopupConfigs.primaryOnClick}> {props.customPopupConfigs.primaryButtonText}</button> }
                            {props.customPopupConfigs.secondaryOnClick && <button class={`button secondary ${props.customPopupConfigs.secondaryButtonStyleIsUnderline?"custom-popup-underline" :"custom-popup-button"}`} 
                              onClick={props.customPopupConfigs.secondaryOnClick}>{props.customPopupConfigs.secondaryButtonText}</button>}
                        </div>
                    </div>
                </div>

            </div>

        </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        shouldShowCustomPopup: state.store.shouldShowCustomPopup,
        customPopupConfigs: state.store.customPopupConfigs,
    }
}
export default connect(mapStateToProps, {})(CustomPopup)